export const LOGIN_SETTINGS_LABELS = {
	USER_NAME_SELECTOR_TOOLTIP_TITLE: 'User Name Selector',
	PASSWORD_SELECTOR_TOOLTIP_TITLE: 'Password Selector'
} as const;
